export default "__VITE_ASSET__Bsh3rXkn__"